module.exports = __webpack_public_path__ + "img/15.cc7e8343.svg";